/**
 * @class ProductInfo
 * @extends HTMLElement
 */

if (!customElements.get("od-product-info")) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this._onVariantChanged = this._onVariantChange.bind(this);
    }

    get enableHistoryState() {
      return this.getAttribute("enable-history-state") === "true";
    }

    connectedCallback() {
      this.productForm = document.forms[this.getAttribute("form")];
      this.productForm?.addEventListener("variant:change", this._onVariantChanged);
    }

    disconnectedCallback() {
      this.productForm?.removeEventListener("variant:change", this._onVariantChanged);
    }

    _onVariantChange(event) {
      const variant = event.detail.variant;

      if (!variant) {
        return;
      }

      this._updateBrowserHistoryState(variant);
    }

    _updateBrowserHistoryState(variant) {
      if (!this.enableHistoryState) {
        return;
      }

      const url = theme.getProductUrlWithVariant(window.location.href, variant.id);
      window.history.replaceState({ path: url }, "", url);
    }
  }

  customElements.define("od-product-info", ProductInfo);
}

/**
 * @class ProductSlider
 * @extends BaseSlider
 */

if (!customElements.get("od-product-slider")) {
  class ProductSlider extends BaseSlider {
    constructor() {
      super();

      this._onSlideChanged = this.onSlideChange.bind(this);
    }

    get options() {
      const thumbnailsSelector = this.getAttribute("thumbnails");
      const thumbnailsElement = thumbnailsSelector ? document.querySelector(thumbnailsSelector) : null;
      const thumbnailsSwiperInstance = thumbnailsElement?.swiperInstance;

      return {
        ...super.options,
        on: {
          slideChange: this._onSlideChanged
        },
        ...(thumbnailsSwiperInstance && {
          thumbs: {
            swiper: thumbnailsSwiperInstance
          }
        })
      }
    }

    onSlideChange() {
      const previousSlide = this.slides.find((slide) => {
        return parseInt(slide.getAttribute("data-index")) === parseInt(this.swiperInstance.previousIndex)
      });

      const videoPlayerElement = previousSlide.querySelector("video-player");

      if (videoPlayerElement) {
        videoPlayerElement.pause();
      }
    }
  }

  customElements.define("od-product-slider", ProductSlider);
}
